// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.auditEventExchangeDetails_label__NXCLI {
    margin: 0 1rem 1rem 0;
    line-height: 1.2rem;
}

.auditEventExchangeDetails_alertTitle__IikBR {
    margin-left: 1rem;
}

.auditEventExchangeDetails_headerTableContainer__9ULfu {
    background-color: var(--gray);
}

.auditEventExchangeDetails_tableTitle__xsOEd {
    text-align: center;
    font-size: var(--title-3-desktop-size);
    font-style: var(--title);
    font-weight: 100;
}

.auditEventExchangeDetails_table__bkYOo {
    margin-left: 1rem;
}

.auditEventExchangeDetails_responseSection__9nUrH {
    width: 100%;
}

.auditEventExchangeDetails_responseCard__vOx8h {
    width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/pages/auditEventExchangeDetails/auditEventExchangeDetails.module.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,sCAAsC;IACtC,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf","sourcesContent":[".label {\r\n    margin: 0 1rem 1rem 0;\r\n    line-height: 1.2rem;\r\n}\r\n\r\n.alertTitle {\r\n    margin-left: 1rem;\r\n}\r\n\r\n.headerTableContainer {\r\n    background-color: var(--gray);\r\n}\r\n\r\n.tableTitle {\r\n    text-align: center;\r\n    font-size: var(--title-3-desktop-size);\r\n    font-style: var(--title);\r\n    font-weight: 100;\r\n}\r\n\r\n.table {\r\n    margin-left: 1rem;\r\n}\r\n\r\n.responseSection {\r\n    width: 100%;\r\n}\r\n\r\n.responseCard {\r\n    width: 100%;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"label": `auditEventExchangeDetails_label__NXCLI`,
	"alertTitle": `auditEventExchangeDetails_alertTitle__IikBR`,
	"headerTableContainer": `auditEventExchangeDetails_headerTableContainer__9ULfu`,
	"tableTitle": `auditEventExchangeDetails_tableTitle__xsOEd`,
	"table": `auditEventExchangeDetails_table__bkYOo`,
	"responseSection": `auditEventExchangeDetails_responseSection__9nUrH`,
	"responseCard": `auditEventExchangeDetails_responseCard__vOx8h`
};
export default ___CSS_LOADER_EXPORT___;
